// extracted by mini-css-extract-plugin
export var fileUpload = "_dx-1";
export var modalButton = "_dx-0";